<template>
    <div v-if="!!options.desc" class="logo-wrapper">
        <a :href="options.title">
            <Stena
                v-if="isStena"
                :title="options.title"
                :desc="options.desc"
                :theme="theme"
                class="stenaline-logo" />
            <Dtf
                v-else-if="showDtfLogo"
                :title="options.title"
                :desc="options.desc"
                :theme="theme"
                class="company-logo" />
            <Sembo
                v-else
                :title="options.title"
                :desc="options.desc"
                :theme="theme"
                class="company-logo" />
        </a>
    </div>
</template>

<script lang="ts">
    import { computed, defineComponent, PropType } from 'vue';
    import { LogoOptions, Market, Markets } from '@shared/config/market/market.models';
    import { isStenaCompany } from '@shared/config/market/market.helpers';
    import { LogoTheme } from '../Layout.interfaces';
    import Sembo from './Sembo/Sembo.vue';
    import Stena from './Stena/Stena.vue';
    import Dtf from './Dtf/Dtf.vue';

    export default defineComponent({
        name: 'Logo',
        components: { Sembo, Stena, Dtf },
        props: {
            market: {
                type: Object as PropType<Market>,
                required: true,
            },
            theme: {
                type: String as PropType<LogoTheme>,
                default: 'default',
            },
        },
        setup(props) {
            const isStena = computed(() => isStenaCompany(props.market.number));

            const showDtfLogo = computed(() =>
                [Markets.DENMARK, Markets.DTFDENMARK].includes(props.market.number)
            );

            const options = computed(
                (): LogoOptions => ({
                    title: props.market.homePage,
                    desc: props.market.name,
                })
            );

            return {
                isStena,
                showDtfLogo,
                options,
            };
        },
    });
</script>

<style lang="scss" scoped>
    @forward 'Logo';
</style>
